import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProfileAPI } from "pages/profile/profile.service";
const initialState = {
  data: null,
  state: ""
};
export const LeaveCountSlice = createSlice({
  name: "leaveCount",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getLeaveCount.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getLeaveCount.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getLeaveCount = createAsyncThunk('LeaveCount/get', async(query) => {
  let data = await ProfileAPI.getLeaveCount();
  return data['totalCount'];

});


export default LeaveCountSlice.reducer;